module.exports = __webpack_public_path__ + "static/media/ad-tray-ad-small.3fceb2a4.svg";